import React from 'react'
import TextMessages from './TextMessages'
import TextMessageEditor from './TextMessageEditor'
import { useCandidateChat } from '../CandidateChatContext'
import { useMediaQuery } from '../../../../hooks/useMediaQuery'

/**
 * Wide-frame breakpoint (CC-UX-022): chat panel width inside the iframe/page.
 * Default embedded panel is 250–350px; layout changes only when the panel is
 * expanded (or full-width below 1250px viewport) past this threshold.
 */
export const WIDE_CHAT_FRAME_MIN_PX = 560

/**
 * TextChatWrap component - main container for text chat functionality
 * Based on the op_next design from app/views/home/coach_chat/content/_text_chat_wrap.html.erb
 *
 * @param {Object} props
 * @param {Array} props.messages - Array of chat messages
 * @param {string} props.chatStatus - Current chat status
 * @param {Object} props.selectedCoach - The currently selected coach
 * @param {boolean} [props.wideFrameLayout] - Optional override from parent layout
 */
const TextChatWrap = ({
  messages,
  chatStatus,
  selectedCoach,
  wideFrameLayout,
}) => {
  const { getBackgroundClass } = useCandidateChat()

  const matchesWideQuery = useMediaQuery(
    `(min-width: ${WIDE_CHAT_FRAME_MIN_PX}px)`,
  )
  const isWideFrame =
    typeof wideFrameLayout === 'boolean' ? wideFrameLayout : matchesWideQuery

  // Narrow frame: preserve existing vertical stack completely.
  // Wide frame: guarantee a scrollable message pane so sent messages stay visible.
  const wrapClassName = isWideFrame
    ? `text-chat-wrap text-chat-wrap--wide grid h-full min-h-0 w-full grid-rows-[minmax(8rem,1fr)_auto] ${getBackgroundClass()}`
    : `text-chat-wrap grid h-full min-h-0 w-full grid-rows-[1fr_auto] ${getBackgroundClass()}`

  return (
    <div className={wrapClassName}>
      {/* Messages area - takes up remaining space; independently scrollable */}
      <div className="min-h-0 overflow-hidden">
        <TextMessages
          messages={messages}
          scrollToBottomOnMount={true}
          isWideFrame={isWideFrame}
        />
      </div>

      {/* Message input and send button */}
      <TextMessageEditor
        chatStatus={chatStatus}
        selectedCoach={selectedCoach}
      />
    </div>
  )
}

export default TextChatWrap
